import * as React from "react";
import * as DetailTopBar from "./DetailTopBar";
import { groupAuth } from "app/utils/authGroups";
import { withRouter } from "react-router";
class UserDetailTopBar extends React.Component<any, any> {
  render() {
    return (
      <DetailTopBar.Bar>
        <DetailTopBar.Item
          text="Summary"
          link={`/snapscan/ops/users/${this.props.match.params.id}/summary`}
        />
        <DetailTopBar.Item
          text="Payments"
          link={`/snapscan/ops/users/${this.props.match.params.id}/payments`}
        />
        <DetailTopBar.Item
          text="Wallet Withdrawals"
          link={`/snapscan/ops/users/${this.props.match.params.id}/withdrawals`}
        />
        <DetailTopBar.Item
          text="Recurring Payment Schedules"
          link={`/snapscan/ops/users/${this.props.match.params.id}/recurring_payment_schedules`}
        />
        <DetailTopBar.Item
          text="Map"
          link={`/snapscan/ops/users/${this.props.match.params.id}/map`}
        />
        <DetailTopBar.Item
          text="Graph"
          link={`/snapscan/ops/users/${this.props.match.params.id}/graph`}
        />
        <DetailTopBar.Item
          text="Linked Users"
          link={`/snapscan/ops/users/${this.props.match.params.id}/linked_users`}
        />
        {groupAuth.hasAccessGroup(["Wallet/Staff", "Wallet/Admin"]) ? (
          <DetailTopBar.Item
            text="Events"
            link={`/snapscan/ops/users/${this.props.match.params.id}/events`}
          />
        ) : null}
        {groupAuth.hasAccessGroup(["Ops/Staff", "Ops/Admin"]) ? (
          <DetailTopBar.Item
            text="Verification"
            link={`/snapscan/ops/users/${this.props.match.params.id}/verification`}
          />
        ) : null}
      </DetailTopBar.Bar>
    );
  }
}
const UserDetailTopBarWithRouter = withRouter(UserDetailTopBar);
export default UserDetailTopBarWithRouter;
